import React, { useState } from "react";
import PlayerSettings from "../components/Computer/PlayerSettings";
import ComputerBoard from "../components/Computer/ComputerBoard";

const Computer = () => {
  const [gridSize, setGridSize] = useState(0);
  const [firstMove, setFirstMove] = useState("");
  const [players, setPlayers] = useState([]);

  const handleStartGame = (move, size) => {
    setFirstMove(move);
    setGridSize(size);
    if (move === "player") {
      setPlayers(["Player", "Computer"]);
    } else {
      setPlayers(["Computer", "Player"]);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <h1 className="text-3xl font-bold mb-6">Dots Connect</h1>
      <div>
        {firstMove === "" || gridSize === 0 ? (
          <PlayerSettings onStart={handleStartGame} />
        ) : (
          <ComputerBoard gridSize={gridSize} players={players} />
        )}
      </div>
    </div>
  );
};

export default Computer;
